module.exports = __webpack_public_path__ + "img/memolife-heart.221e8499.svg";